module.exports = __webpack_public_path__ + "media/background-video.6de8193d.mp4";